import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { CompanyManager } from "../../managers.types";
import { requestGetManagers } from "./getManagers.request";

export const COMPANY_MANAGERS_QUERY_KEY = "company-managers";

const useGetManagers = (
  search?: string,
  options?: QueryOptions<CompanyManager[], ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: [COMPANY_MANAGERS_QUERY_KEY, search ?? ""],
    queryFn: () => requestGetManagers(search),
    ...options
  });

  return { managers: data ?? [], ...rest };
};

export default useGetManagers;
